'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var applyDefaultOptions = require('./utils/apply-default-options');

var stat = require('./stat');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

var defaultOptions = {};

module.exports = function (context) {
  return withTimeoutOption( /*#__PURE__*/function () {
    var _mfsFlush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var path,
          options,
          result,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              path = _args.length > 0 && _args[0] !== undefined ? _args[0] : '/';
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultOptions;

              if (path && typeof path !== 'string') {
                options = path;
                path = '/';
              }

              options = applyDefaultOptions(options, defaultOptions);
              _context.next = 6;
              return stat(context)(path, options);

            case 6:
              result = _context.sent;
              return _context.abrupt("return", result.cid);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mfsFlush() {
      return _mfsFlush.apply(this, arguments);
    }

    return mfsFlush;
  }());
};